<template>
  <article class="result-item">
    <Amount><component class="icon" :is="icon" /> {{ amount }}</Amount>
    <Description>{{ description }}</Description>
  </article>
</template>

<script>
import Amount from './Amount'
import Description from './Description'

export default {
  name: 'ResultItem',
  props: {
    amount: {
      type: [String, Number],
      required: true
    },
    description: {
      type: String,
      required: true
    },
    icon: {
      required: true
    }
  },
  components: {
    Amount,
    Description
  }
}
</script>

<style lang="scss" scoped>
.result-item {
  padding: 0.75em;
}

.icon {
  margin-right: 8px;
  display: inline-block;
  vertical-align: middle;
  margin-top: -5px;
}
</style>
